import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase project config — override via VITE_FIREBASE_* env vars for dev project.
// Defaults are production (racemarksapp). Canonical values: config/firebase/*.env
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAmbyy62lGg2_qBlWMWyVjZYEc-O3offa8',
  authDomain: import.meta.env.DEV
    ? (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'racemarksapp.firebaseapp.com')
    : (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'committee.racemarks.app'),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'racemarksapp',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'racemarksapp.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '44353887422',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:44353887422:web:2b31938670e54ad981d2ef',
};

/** True only when pointing at the production Firebase project. */
export const isProduction = firebaseConfig.projectId === 'racemarksapp';

export const app = initializeApp(firebaseConfig);

// App Check — protects Cloud Functions from unauthorized callers.
// Only initialize when a reCAPTCHA site key is configured (skip in local dev without key).
if (import.meta.env.VITE_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const functions = getFunctions(app);

// Connect to emulators in development
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
